const hiddenClass = 'selling_plan_theme_integration--hidden';

class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.updateSellingPlanInputsValues();
    this.listenToVariantChange();
    this.listenToSellingPlanFormRadioButtonChange();
    this.updatePrice();
  }

  radioChangeEventsAdded = false

  get shopifySection() {
    return document.querySelector(".section-product-info")
  }

  get variantIdInput() {
    return this.addToCartForms[0]?.querySelector(`input[name="id"]`)
  }

  get visibleSellingPlanForm() {
    return this.shopifySection.querySelector(
      `section[data-variant-id^="${this.variantIdInput?.value ?? ''}"]`,
    );
  }

  get addToCartForms() {
    return this.shopifySection.querySelectorAll('[action*="/cart/add"]');
  }

  showSellingPlanForm(sellingPlanFormForSelectedVariant) {
    sellingPlanFormForSelectedVariant?.classList?.remove(hiddenClass);
  }

  hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
    sellingPlanFormsForUnselectedVariants.forEach((element) => {
      element.classList.add(hiddenClass);
    });
  }

  handleSellingPlanFormVisibility() {
    const sellingPlanFormForSelectedVariant = this.shopifySection.querySelector(
      `section[data-variant-id="${this.variantIdInput?.value ?? ''}"]`,
    );
    const sellingPlanFormsForUnselectedVariants =
      this.shopifySection.querySelectorAll(
        `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput?.value ?? ''}"])`,
      );
    this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
    this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);
  }

  handleVariantChange() {
    this.handleSellingPlanFormVisibility();
    this.updateSellingPlanInputsValues();
  }

  listenToVariantChange() {
    this.listenToAddToCartForms();
    
    if (this.variantIdInput?.tagName === 'INPUT') {
      const variantIdObserver = new MutationObserver((mutationList) => {
        mutationList.forEach((mutationRecord) => {
          this.handleVariantChange(mutationRecord.target.value);
        });
      });

      variantIdObserver.observe(this.variantIdInput, {attributes: true});
    }
  }

  listenToAddToCartForms() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.addEventListener('change', () => this.handleVariantChange());
    });
  }

  updatePrice() {
    const pricesToExchange = document.querySelectorAll('.price-value-to-exchange')
    if (pricesToExchange.length && this.selectedPurchaseOption && this.selectedPurchaseOption.dataset.variantPrice) {
      pricesToExchange.forEach((p) => {
        if (!p.closest('.card-product')) {
          p.textContent = this.selectedPurchaseOption.dataset.variantPrice
        }
      })
    }
  }

  get sellingPlanInputs() {
    return [...this.shopifySection.querySelectorAll('.selected-selling-plan-id'), this.shopifySection.querySelector(".selected-selling-plan-id--sticky")].filter(Boolean);
  }

  updateSellingPlanInputsValues() {
    const newVal = this.selectedPurchaseOption?.dataset.sellingPlanId ?? null
    this.sellingPlanInputs.forEach((sellingPlanInput) => {
      sellingPlanInput.value = newVal;
    });
  }

  get selectedPurchaseOption() {
    return this.visibleSellingPlanForm?.querySelector(
      'input[type="radio"]:checked',
    );
  }

  set selectedPurchaseOption(selectedPurchaseOption) {
    this._selectedPurchaseOption = selectedPurchaseOption;
  }

  handleRadioButtonChange(selectedPurchaseOption) {
    this.selectedPurchaseOption = selectedPurchaseOption;
    this.updateSellingPlanInputsValues();
    this.updatePrice();
  }

  listenToSellingPlanFormRadioButtonChange() {
    if (this.radioChangeEventsAdded) return

    this.radioChangeEventsAdded = true;
    this.sellingPlansWidgetContainer.addEventListener('input', (event) => {      
      const radio = event.target.closest('.selling_plan_theme_integration input[type="radio"]');
      
      if (!radio) return;

      this.handleRadioButtonChange(radio);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sellingContainers = document.querySelectorAll('.selling_plan_container')
  
  sellingContainers.forEach((sellingPlansWidgetContainer) => {
    new SellingPlansWidget(sellingPlansWidgetContainer);
  });
})
